(function ($) {
    // remove image, load and play video
    $( 'a.play-franchisee-video-button' ).click(function(){
        // Remove every playing video
        $(".play-franchisee-video-button .video-container").remove();

        let currentVideoContainer = $(this);
        let videoId = $( this ).attr( 'videoId' );
        let videoTitle = $( this ).attr( 'videoTitle' );

        // Reset every active video
        $( ".play-franchisee-video-button").each( function() {
            if( $(this).hasClass('active-video') ) {
                $(this).removeClass('active-video');
            }
        });
        $( currentVideoContainer ).addClass('active-video');
        $( currentVideoContainer ).append(
            '<div class="video-container">' + 
                '<iframe width="100%" height="100%" src="https://www.youtube.com/embed/' + videoId + '?autoplay=1&mute=0&controls=1&loop=0&modestbranding=0&fs=0&disablekb=0&playsinline=0&showinfo=0&rel=0&autohide=1&start=0&end=0&enablejsapi=1" loop title="' + videoTitle + '" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="1"></iframe>' +
            '</div>'
        );
    });
})(jQuery);